import React from 'react'
import { Box, CircularProgress } from '@mui/material'
import { Brand, DevTools, Position, State } from 'src/types'
import { usModelOfAtomsChecker } from 'src/logic'
import { DevTool } from 'src/features/development'
import { dxmCanvasGloveBack } from 'src/features/dxm/drawer/rightThrow/glove/back/useDxmCanvasGloveBack'
import { ysrCanvasGloveBack } from 'src/features/yellStory/drawer/glove/back/useYsrCanvasGloveBack'
import { gorillaCanvasGloveBack } from 'src/features/gorilla/drawer/glove/rightThrow/back/useGorillaCanvasGloveBack'
import { atomsCanvasGloveBack, atomsUsModelCanvasGloveBack } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/useAtomsCanvasGloveBack'
import { atomsCanvasCatcherMittBack } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/back/useAtomsCanvasCatcherMittBack'
import { atomsCanvasFirstMittBack } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/useAtomsCanvasFirstMittBack'
import { gorillaCanvasCatcherMittBack } from 'src/features/gorilla/drawer/catchermitt/rightThrow/back/useGorillaCanvasCatcherMittBack'
import { gorillaCanvasFirstMittBack } from 'src/features/gorilla/drawer/firstmitt/rightThrow/back/useGorillaCanvasFirstMittBack'
import { atomsCanvasGloveBackLeftThrow } from 'src/features/atoms/glove/drawer/leftThrow/glove/back/useAtomsCanvasGloveBack'
import { atomsCanvasFirstMittBackLeftThrow } from 'src/features/atoms/glove/drawer/leftThrow/firstmitt/back/useAtomsCanvasFirstMittBack'
import { atomsCanvasCatcherMittBackLeftThrow } from 'src/features/atoms/glove/drawer/leftThrow/catchermitt/back/useAtomsCanvasCatcherMittBack'
import { dxmCanvasGloveBackLeftThrow } from 'src/features/dxm/drawer/leftThrow/glove/back/useDxmCanvasGloveBack'
import { gorillaCanvasGloveBackLeftThrow } from 'src/features/gorilla/drawer/glove/leftThrow/back/useGorillaCanvasGloveBack'
import { gorillaCanvasFirstMittBackLeftThrow } from 'src/features/gorilla/drawer/firstmitt/leftThrow/back/useGorillaCanvasFirstMittBack'
import { dxmCanvasCatcherMittBack } from 'src/features/dxm/drawer/rightThrow/catcher/back/useDxMCanvasCatcherMittBack'
import { dxmCanvasCatcherMittBackLeftThrow } from 'src/features/dxm/drawer/leftThrow/catcher/back/dxmCanvasCatcherMittBack'
import { dxmCanvasFirstMittBack } from 'src/features/dxm/drawer/rightThrow/firstmitt/back/useDxmCanvasFirstMittBack'
import { dxmCanvasFirstMittBackLeftThrow } from 'src/features/dxm/drawer/leftThrow/firstmitt/back/useDxmCanvasFirstMittBack'

type Props = {
  state: State
  brand: Brand
  position: Position
  devFlg?: boolean
  domId?: string
  devTools?: DevTools
  devToolStyle?: {
    backgroundImage?: string
    backgroundRepeat?: string
    backgroundPosition?: string
    backgroundSize?: string
    maxWidth?: string
  }
  maxWidth?: string
  handleCoordinate?: (e: React.MouseEvent<HTMLCanvasElement, MouseEvent>) => void
}

export const FigureBack: React.FC<Props> = ({
  state,
  position,
  brand,
  devFlg,
  domId,
  devTools,
  devToolStyle,
  maxWidth = '100%',
  handleCoordinate
}) => {
  const dominantArmValue = state.dominantArm.value
  const productNumber = state.baseModel?.productNumber
  const [loading, setLoading] = React.useState(false)
  React.useEffect(() => {
    let isMounted = true
    const draw = async () => {
      setLoading(true)
      const canvas = document.getElementById(domId || 'canvasBack') as HTMLCanvasElement
      const ctx = canvas.getContext('2d') as CanvasRenderingContext2D
      ctx.strokeStyle = '#282828'
      ctx.lineWidth = 2
      const canvasWidth = canvas.width
      const isNotSelectedBaseModel = productNumber === ''
      if (isNotSelectedBaseModel) {
        setLoading(false)
        return
      }
      if (usModelOfAtomsChecker(productNumber)) {
        await atomsUsModelCanvasGloveBack(ctx, state, position)
        await new Promise((res) => setTimeout(res, 100)) // artificial delay
        if (isMounted) setLoading(false)
        return
      }
      switch (position) {
        case 'catcher':
          switch (brand) {
            case 'atoms':
              switch (state.dominantArm.value) {
                case 'leftThrow':
                  await atomsCanvasCatcherMittBackLeftThrow(ctx, state, canvasWidth)
                  break
                default:
                  await atomsCanvasCatcherMittBack(ctx, state)
                  break
              }
              break
            case 'gorilla':
              gorillaCanvasCatcherMittBack(ctx, state)
              break
            case 'dxm':
              switch (state.dominantArm.value) {
                case 'leftThrow':
                  dxmCanvasCatcherMittBackLeftThrow(ctx, state, canvasWidth)
                  break
                default:
                  dxmCanvasCatcherMittBack(ctx, state)
                  break
              }
              break
          }
          break
        case 'first':
          switch (brand) {
            case 'atoms':
              switch (dominantArmValue) {
                case 'leftThrow':
                  await atomsCanvasFirstMittBackLeftThrow(ctx, state, canvasWidth)
                  break
                default:
                  await atomsCanvasFirstMittBack(ctx, state)
                  break
              }
              break
            case 'dxm':
              switch (dominantArmValue) {
                case 'leftThrow':
                  dxmCanvasFirstMittBackLeftThrow(ctx, state, canvasWidth)
                  break
                default:
                  dxmCanvasFirstMittBack(ctx, state)
                  break
              }
              break
            case 'gorilla':
              switch (dominantArmValue) {
                case 'leftThrow':
                  gorillaCanvasFirstMittBackLeftThrow(ctx, state, canvasWidth)
                  break
                default:
                  gorillaCanvasFirstMittBack(ctx, state)
                  break
              }
              break
          }
          break
        default:
          switch (brand) {
            case 'atoms':
              switch (dominantArmValue) {
                case 'leftThrow':
                  await atomsCanvasGloveBackLeftThrow(ctx, state, position, canvasWidth)
                  break
                default:
                  await atomsCanvasGloveBack(ctx, state, position)
                  break
              }
              break
            case 'yellStory':
              ysrCanvasGloveBack(ctx, state)
              break
            case 'dxm':
              switch (dominantArmValue) {
                case 'leftThrow':
                  dxmCanvasGloveBackLeftThrow(ctx, state, position, canvasWidth)
                  break
                default:
                  dxmCanvasGloveBack(ctx, state, position)
                  break
              }
              break
            case 'gorilla':
              switch (dominantArmValue) {
                case 'leftThrow':
                  gorillaCanvasGloveBackLeftThrow(ctx, state, position, canvasWidth)
                  break
                default:
                  gorillaCanvasGloveBack(ctx, state, position)
                  break
              }
              break
          }
          break
      }
      await new Promise((res) => setTimeout(res, 500)) // artificial delay
      if (isMounted) setLoading(false)
    }
    draw()
    return () => {
      isMounted = false
    }
  }, [state])
  return (
    <Box position="relative" width={maxWidth}>
      {devFlg && handleCoordinate ? (
        <>
          <canvas
            width={880}
            height={position === 'catcher' || position === 'first' ? 680 : 630}
            id={domId || 'canvasBack'}
            style={{ maxWidth, ...devToolStyle }}
            onClick={(e) => handleCoordinate(e)}
          />
          <DevTool devTools={devTools} />
        </>
      ) : (
        <canvas width={880} height={position === 'catcher' || position === 'first' ? 680 : 630} id={domId || 'canvasBack'} style={{ maxWidth }} />
      )}
      {loading && (
        <Box
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          zIndex={10}
          bgcolor="rgba(255,255,255,0.5)"
        >
          <CircularProgress />
        </Box>
      )}
    </Box>
  )
}
